import React from "react";
import { AppleCountFeatureProperties } from "../../layer.types";

export function CalibratedTreeCount({
  properties,
}: {
  properties: AppleCountFeatureProperties;
}): React.ReactNode {
  return <strong>{Math.round(properties.calibrated_count ?? 0)}</strong>;
}
